// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var EmailsController = function ($scope, $location, $routeParams, $http, Email) {
    $scope.wasSearching = false;
    $scope.filter = { search: $routeParams.entityId, status: $location.search()["status"] };

    $scope.updateFilter = function () {
        $scope.emails = $scope.paginator(function (options, callback) {
            return Email.query(options, function () { callback(); $scope.wasSearching = options.search; });
        }, { search: $scope.filter.search, statusFilter: $scope.filter.status }, 100);
    };

    $scope.updateFilter();

    function requeueEmail(id) {
        $http.post('/api/v1/emails/' + id + '/requeue', {}).success(function () { $scope.updateFilter(); });
    }

    $scope.requeueEmail = function (id) {
        $scope.confirm('Email', 'Are you sure you want to requeue this email?', requeueEmail.bind(this, id))
    }
    
    $scope.resetFilters = function() {
        $scope.filter = {
            search: '',
            status: ''
        };
        $scope.updateFilter();
    }
};
EmailsController.$inject = ['$scope', '$location', '$routeParams', '$http', 'Email'];
